<div class="d-flex align-items-center flex-wrap flex-md-nowrap pt-2">
  <div class="flex-grow-1 title-container eip-mb-xs-10  eip-mt-xs-10">
    <p><span class="fs-16 ff-3 line-height-1">
        {{pageTitle | uppercase}}
      </span></p>
  </div>
  <div class="pagination-container d-flex flex-wrap flex-sm-nowrap align-items-center" *ngIf="showDateDetails && projectDetail">
    <div class="flex-fill bd-highlight eip-mb-xs-10">
      <p>Project Start Date: <span class='font-weight-bold eip-pr-20'>
          <!-- 12-Apr-2012 -->
          <!-- {{projectDetail.startDate | date:'dd-mmm-yyyy'}} -->
          {{ projectStartDate }}</span></p>
    </div>
    <div class="flex-fill bd-highlight eip-mb-xs-10">
      <p>Project End Date: <span class='font-weight-bold'>
          <!-- 12-Apr-2012 -->
          <!-- {{projectDetail.endDate | date:'dd-mmm-yyyy'}} -->
          {{ projectEndDate }}
        </span></p>
    </div>
  </div>
  <div class="divider-container d-none d-md-block eip-mx-10" id="imgDivider" *ngIf="showDateDetails && projectDetail">
    <span></span>
  </div>
  <div class="bd-highlight d-flex align-items-center" *ngIf="showDateDetails && projectDetail">
    <p>Lapse Period: <span class='font-weight-bold'>
        {{diffInYears}} year{{diffInYears > 1 ? 's':'' }}
      </span>
    </p>
    <mat-progress-bar class="eip-ml-10" color="green" [value]="daysCompletionPercentage" width="150"
      id="imgProgressBar">
    </mat-progress-bar>
  </div>
  <div class="divider-container d-none d-md-block  eip-mx-10 " id="imgDivider" *ngIf="showDateDetails && projectDetail">
    <span></span>
  </div>
  <div class="d-flex align-items-center bd-highlight" style="white-space: nowrap;" *ngIf="showProjectList"
    title="{{ (projectDetail && projectDetail.projectDescription) ? projectDetail.projectDescription : '' }}">
    <p class="eip-mr-10"><span>Project Name:</span>
    <div style="width:73%;">
      <form [formGroup]="projectForm"  autocomplete="off">
        <edms-autocomplete [data]="projectList" [form]="projectForm" controlName="project" textField="projCodeDesc"
          label="" error="Select project" (optionSelected)="changeProject($event)">
        </edms-autocomplete>
      </form> 
    </div> 
  </div>
  
</div><div class="main-section"></div>